import { computed, ref, unref } from 'vue';
import { useWindowSizeFn } from '@mts-fe/hooks';
import { createPageContext } from '@mts/hooks/component/usePageContext';
import { windowSize } from '@mts/utils';
import { PCMode } from '@mts/utils/env';

const headerHeightRef = ref(0);
const footerHeightRef = ref(0);

export function useLayoutHeight() {
  function setHeaderHeight(val) {
    headerHeightRef.value = val;
  }
  function setFooterHeight(val) {
    footerHeightRef.value = val;
  }
  return { headerHeightRef, footerHeightRef, setHeaderHeight, setFooterHeight };
}

export function useContentViewHeight() {
  const contentHeight = ref(windowSize.height);
  const pageHeight = ref(windowSize.height);
  const getViewHeight = computed(() => {
    return unref(contentHeight) - unref(headerHeightRef) - unref(footerHeightRef) || 0;
  });

  PCMode &&
    useWindowSizeFn(
      () => {
        contentHeight.value = window.innerHeight;
      },
      { wait: 100, immediate: true },
    );

  async function setPageHeight(height: number) {
    pageHeight.value = height;
  }

  createPageContext({
    contentHeight: getViewHeight,
    setPageHeight,
    pageHeight,
  });
}
